var components
try {
  components = {
    yiLoading: function () {
      return import(
        /* webpackChunkName: "components/yi-loading/yi-loading" */ "@/components/yi-loading/yi-loading.vue"
      )
    },
    yiNavHeader: function () {
      return import(
        /* webpackChunkName: "components/yi-nav-header/yi-nav-header" */ "@/components/yi-nav-header/yi-nav-header.vue"
      )
    },
    uIcon: function () {
      return import(
        /* webpackChunkName: "node-modules/uview-ui/components/u-icon/u-icon" */ "uview-ui/components/u-icon/u-icon.vue"
      )
    },
    uSearch: function () {
      return import(
        /* webpackChunkName: "node-modules/uview-ui/components/u-search/u-search" */ "uview-ui/components/u-search/u-search.vue"
      )
    },
    yiUserAvatar: function () {
      return import(
        /* webpackChunkName: "components/yi-user-avatar/yi-user-avatar" */ "@/components/yi-user-avatar/yi-user-avatar.vue"
      )
    },
    uCellGroup: function () {
      return import(
        /* webpackChunkName: "node-modules/uview-ui/components/u-cell-group/u-cell-group" */ "uview-ui/components/u-cell-group/u-cell-group.vue"
      )
    },
    uCellItem: function () {
      return import(
        /* webpackChunkName: "node-modules/uview-ui/components/u-cell-item/u-cell-item" */ "uview-ui/components/u-cell-item/u-cell-item.vue"
      )
    },
    uPopup: function () {
      return import(
        /* webpackChunkName: "node-modules/uview-ui/components/u-popup/u-popup" */ "uview-ui/components/u-popup/u-popup.vue"
      )
    },
    yiAuthorize: function () {
      return import(
        /* webpackChunkName: "components/yi-authorize/yi-authorize" */ "@/components/yi-authorize/yi-authorize.vue"
      )
    },
  }
} catch (e) {
  if (
    e.message.indexOf("Cannot find module") !== -1 &&
    e.message.indexOf(".vue") !== -1
  ) {
    console.error(e.message)
    console.error("1. 排查组件名称拼写是否正确")
    console.error(
      "2. 排查组件是否符合 easycom 规范，文档：https://uniapp.dcloud.net.cn/collocation/pages?id=easycom"
    )
    console.error(
      "3. 若组件不符合 easycom 规范，需手动引入，并在 components 中注册该组件"
    )
  } else {
    throw e
  }
}
var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  var m0 = require("../../../static/logo.png")

  if (!_vm._isMounted) {
    _vm.e0 = function ($event) {
      $event.stopPropagation()
      return _vm.$store.dispatch("user/loginByPhone", "login")
    }

    _vm.e1 = function ($event) {
      return _vm.$store.dispatch("user/logout")
    }
  }

  _vm.$mp.data = Object.assign(
    {},
    {
      $root: {
        m0: m0,
      },
    }
  )
}
var recyclableRender = false
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns, recyclableRender, components }